// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2yz1t","inner":"Footer_inner__21j-A"};